import type { components } from '@trackercop/contracts';
import { cn } from '@/lib/utils';

type ReviewStatus = components['schemas']['ReviewStatus'];

const styles: Record<ReviewStatus, { bg: string; text: string; label: string }> = {
  unreviewed: { bg: 'bg-neutral-300/40', text: 'text-neutral-700', label: 'Unreviewed' },
  acknowledged: { bg: 'bg-sky-500/20', text: 'text-sky-700', label: 'Acknowledged' },
  approved: { bg: 'bg-emerald-600/20', text: 'text-emerald-700', label: 'Approved' },
  flagged: { bg: 'bg-red-600/20', text: 'text-red-700', label: 'Flagged' },
};

export function ReviewStatusChip({ status, onClick }: { status: ReviewStatus; onClick?: () => void }) {
  const palette = styles[status];
  const Tag = onClick ? 'button' : 'span';
  return (
    <Tag
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        palette.bg,
        palette.text,
        onClick && 'cursor-pointer hover:brightness-95',
      )}
      data-testid={`review-status-chip-${status}`}
    >
      {palette.label}
    </Tag>
  );
}
